<div class="sx-metering-point__tab-content">

  <!-- Filter för anläggningar -->
  <app-metering-points-filter
    [filter]="filter"  
    (meteringPointsFilterEvent)="meteringPointsFilterEventHandler($event)" 
    (meteringPointsViewEvent)="meteringPointsViewHandler($event)"
    (export)="onExport()" 
    [tableView]="tableView"  
    [isExporting]="isExporting"
    [isMobile]="isMobile"
    [paneType]="paneType">
  </app-metering-points-filter>
 
  <div *ngIf="groupingEnabled && hasManageGroupPermission" class="sxl-align-right sxl-horizontal-stack-small sx-metering-point__btngroup">
    <button id="meteringpoints_virtualfilter_inactive_btn_{{paneType}}" attr.aria-label="{{'meteringpoints.filter_selected' | translate}}" *ngIf="!virtualGroupActivated" mat-button class="sx-button sx-button--icon" [disabled]="selectedMeteringPointIds.length === 0"
      [ngClass]="{'sx-button--blue': selectedMeteringPoints && selectedMeteringPoints.length > 0}" (click)="createVirtualGroup()">
      <svg>
        <use xlink:href="#baseline-add-24px" href="#baseline-add-24px" />
      </svg>
      <span aria-hidden="true" class="sx-metering-point__btngroup-short">{{'meteringpoints.filter_selected_short' | translate}}</span>
    </button>
    <button id="meteringpoints_virtualfilter_active_btn_{{paneType}}"  attr.aria-label="{{'meteringpoints.filter_unselect' | translate}}"  *ngIf="virtualGroupActivated" mat-button class="sx-button sx-button--icon" [disabled]="selectedMeteringPointIds.length === 0"
      [ngClass]="{'sx-button--blue': selectedMeteringPoints && selectedMeteringPoints.length > 0}" (click)="removeVirtualGroup()">
      <svg>
        <use xlink:href="#baseline-undo-24px" href="#baseline-undo-24px" />
      </svg>
      <span aria-hidden="true" class="sx-metering-point__btngroup-short">{{'meteringpoints.filter_unselect_short' | translate}}</span>
    </button>


    <button id="meteringpoints_add_group_btn_{{paneType}}" appTrackClick sxaction="Button meteringpoint add to group"  attr.aria-label="{{'meteringpoints.add_all' | translate}}" mat-button class="sx-button sx-button--icon" [disabled]="selectedMeteringPointIds.length === 0"
      [ngClass]="{'sx-button--blue': selectedMeteringPoints && selectedMeteringPoints.length > 0}" (click)="createNewGroup()">
      <svg>
        <use xlink:href="#baseline-add-24px" href="#baseline-add-24px" />
      </svg>
      <span aria-hidden="true" class="sx-metering-point__btngroup-short">{{'meteringpoints.add_all_short' | translate}}</span>
    </button>
    <button  [hidden]="tableView" id="meteringpoints_select_all_btn_{{paneType}}" appTrackClick sxaction="Button meteringpoint select all" attr.aria-label="{{'meteringpoints.mark_all' | translate}}" mat-button class="sx-button sx-button--icon" (click)="toggleAllVisible(true)">
      <svg>
        <use xlink:href="#baseline-select_all-24px" href="#baseline-select_all-24px" />
      </svg>
      <span aria-hidden="true" class="sx-metering-point__btngroup-short">{{'meteringpoints.mark_all_short' | translate}}</span>
    </button>
    <button  [hidden]="tableView" id="meteringpoints_deselect_all_btn_{{paneType}}" appTrackClick sxaction="Button meteringpoint deselect all"  attr.aria-label="{{'meteringpoints.unmark_all' | translate}}" mat-button class="sx-button sx-button--icon" (click)="toggleAllVisible(false)">
      <svg>
        <use xlink:href="#baseline-undo-24px" href="#baseline-undo-24px" />
      </svg>
      <span aria-hidden="true" class="sx-metering-point__btngroup-short">{{'meteringpoints.unmark_all_short' | translate}}</span>
    </button>
  </div>
  <app-spinner [hidden]="customersWithMeteringPointsViewLoaded"></app-spinner>
  
  <div [hidden]="!customersWithMeteringPointsViewLoaded" *ngIf="!customersWithMeteringPointsView || customersWithMeteringPointsView.length === 0" >
    <app-no-content [displayText]="('meteringpoints.no_data_or_no_result' | translate)"></app-no-content>
  </div>

    <!-- Cards -->
    <div *ngIf="!tableView">
      <section *ngFor="let customer of customersWithMeteringPointsView; let c = index;"
      class="sx-metering-point__customer-section" id="meteringpoints_{{paneType}}_customer_{{c}}">
    
      <mat-expansion-panel [expanded]="customer._expanded" (opened)="panelOpened(customer)"
        (closed)="panelClosed(customer)">
        <mat-expansion-panel-header [collapsedHeight]="'48px'" [expandedHeight]="'48px'">
          <mat-panel-title>
            <h2 class="h3 sx-metering-point__customer-heading">{{customer.name}}
              <span class="sxh-text-small">({{customer.id}})</span>
            </h2>
          </mat-panel-title>
        </mat-expansion-panel-header>
    
        <div class="sx-metering-point__wrapper">
          <div class="sxl-container">
            <div class="sxl-item sxl-item--4" *ngFor="let meteringPoint of customer.meteringPoints; let m = index">
              <article class="sx-metering-point" [ngClass]="{'selected': meteringPoint.selected}"
                id="meteringpoints_{{paneType}}_customer_{{c}}_mp_{{m}}">
                <div class="sx-metering-point__header--clickable sxl-grow" (click)="viewInformation(meteringPoint.id)">
                  <header class="sx-metering-point__header sxl-flex sxl-justify-between">
                    <div class="sx-metering-point__content">
                      <div class="sx-metering-point__heading">{{meteringPoint.name}}</div>
                      <div class="sxh-text-light">{{'meteringpoints.card.id' | translate}} {{meteringPoint.id}}</div>
                    </div>
                    <div *ngIf="!customer.isWhiteLabel" class="sx-metering-point__selection">
                      <mat-checkbox 
                        [(ngModel)]="meteringPoint.selected" 
                        (click)="onMeteringPointCheckboxClick($event)" 
                        (change)="onSelectCardMeteringPoint($event, meteringPoint)">
                      </mat-checkbox>
                    </div>
                  </header>
                  <div class="sx-metering-point__content">
                    <div class="sx-metering-point__row">
                      <div *ngIf="meteringPoint.addresses && meteringPoint.addresses.length > 0" class="sx-metering-point__row-icon">
                        <svg class="sxh-icon-big">
                          <use xlink:href="#sx-position" href="#sx-position" />
                        </svg>
                      </div>
                      <div class="sx-metering-point__row-fragment">
                        <span *ngIf="meteringPoint.addresses && meteringPoint.addresses.length > 0">
                        {{meteringPoint.addresses[0]!.street | titlecase}} {{meteringPoint.addresses[0]!.streetNo}},
                        <br /> {{meteringPoint.addresses[0]!.zip}} {{meteringPoint.addresses[0]!.city | titlecase}}
                        </span>
                      </div>
                    </div>
                    <div class="sx-metering-point__row" *ngIf="filterDisruption(meteringPoint.disruptionInfos)">
                      <ng-container *ngIf="filterDisruption(meteringPoint.disruptionInfos).disturbanceType === DisturbanceTypeEnum.Delivery">
                        <div matTooltip="{{'disruptions.delivery_disruption_tooltip' | translate}}" matTooltipClass="sx-metering-point__tooltip">
                          <div class="sxl-flex">
                            <div class="sx-metering-point__row-icon">
                              <svg class="sx-metering-point__planned-icon">
                                <use xlink:href="#baseline-warning-24px" href="#baseline-warning-24px" />
                              </svg>
                            </div>
                            <div class="sx-metering-point__row-fragment">
                              <span>{{ "disruptions.ongoing-delivery-disruption" | translate }}</span>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="filterDisruption(meteringPoint.disruptionInfos).isPlanned && filterDisruption(meteringPoint.disruptionInfos).disturbanceType !== DisturbanceTypeEnum.Delivery">
                        <div matTooltip="{{'disruptions.delivery_disruption_tooltip' | translate}}" matTooltipClass="sx-metering-point__tooltip">
                          <div class="sxl-flex">
                            <div class="sx-metering-point__row-icon">
                              <svg class="sx-metering-point__planned-icon">
                                <use xlink:href="#baseline-warning-24px" href="#baseline-warning-24px" />
                              </svg>
                            </div>
                            <div class="sx-metering-point__row-fragment">
                              <span>{{ "disruptions.ongoing-planned-disruption" | translate }}</span>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="!filterDisruption(meteringPoint.disruptionInfos).isPlanned && filterDisruption(meteringPoint.disruptionInfos).disturbanceType !== DisturbanceTypeEnum.Delivery">
                        <div matTooltip="{{'disruptions.unplanned_tooltip' | translate}}" matTooltipClass="sx-metering-point__tooltip">
                          <div class="sxl-flex">
                            <div class="sx-metering-point__row-icon">
                              <svg class="sx-metering-point__unplanned-icon">
                                <use xlink:href="#baseline-warning-24px" href="#baseline-warning-24px" />
                              </svg>
                            </div>
                            <div class="sx-metering-point__row-fragment">
                              <span>{{ "disruptions.ongoing-unplanned-disruption" | translate }}</span>
                            </div>
                          </div>
                        </div>  
                      </ng-container>
                    </div>
                   

                    <div class="sx-metering-point__chip-wrapper sxh-horizontal-stack-tiny">
                      <div class="sx-chip sx-chip--purple" *ngIf="meteringPoint.type === 'LOG'">{{'meteringpoints.card.logic_chip'
                        | translate}}
                      </div>
                      <div class="sx-chip sx-chip--magenta" *ngIf="meteringPoint.hasFunctionControl">{{'meteringpoints.card.functionControl'
                        | translate}}
                      </div>
                      <div class="sx-chip sx-chip--blue" *ngIf="meteringPoint.hasIntelligy">{{'meteringpoints.card.hasIntelligy'
                        | translate}}
                      </div>
                      <div class="sx-chip sx-chip--indigo" *ngIf="meteringPoint.isWhiteLabel">{{meteringPoint.externalOrganisationAlias}}</div>
                      <ng-container *ngIf="meteringPoint.parentGroups && meteringPoint.parentGroups.length > 0">
                        <div class="sx-chip" *ngFor="let parentGroup of meteringPoint.parentGroups">
                          {{parentGroup.name}}
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </article>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </section>
    </div>
    
    <!-- Table -->
    <div class="sx-metering-point__table" [hidden]="!tableView">
      <mat-table #table [dataSource]="dataSource" [hidden]="" matSort [matSortActive]="sortActive" [matSortDirection]="sortDirection">

      <ng-container matColumnDef="select">
        <mat-header-cell *matHeaderCellDef >
          <div>
            <mat-checkbox [checked]="toggleAll" (change)="toggleAllItems(toggleAll)" [value]="toggleAll"></mat-checkbox>
          </div>
        </mat-header-cell>
        <mat-cell *matCellDef="let row">
          <section *ngIf="!isWhiteLabelCustomer(row)">
            <mat-checkbox (change)="selectTableMeteringPoint($event, row)" [(ngModel)]="row.selected"></mat-checkbox>
          </section>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="meteringPointId">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'meteringpoints.table.id' | translate}}</mat-header-cell>
        <mat-cell *matCellDef="let row">          
          <span class="mobile-label">{{'meteringpoints.table.id' | translate}}:</span>
          <span><a class="btn" href="javascript:void(0);" (click)="viewInformation(row.id)">{{row.id}}</a></span>          
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="meteringPointName">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'meteringpoints.table.name' | translate}}
        </mat-header-cell>
        <mat-cell [matTooltipShowDelay]="500"  [matTooltip]="row.customerName" *matCellDef="let row">
          <span class="mobile-label">{{'meteringpoints.table.name' | translate}}:</span>
          <span>{{row.name | titlecase }}</span>
        </mat-cell>
      </ng-container> 

      <ng-container matColumnDef="meteringPointAddress">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'meteringpoints.table.address' | translate}}
        </mat-header-cell>
    
        <mat-cell [matTooltipShowDelay]="500" [matTooltip]="row.addresses && row.addresses.length > 0 ? (row.addresses[0]!.street | titlecase) + ' ' + row.addresses[0]!.streetNo + ', ' + row.addresses[0]!.zip + ' ' + (row.addresses[0]!.city | titlecase) : ''"  *matCellDef="let row">
            <span class="mobile-label">{{'meteringpoints.table.address' | translate}}:</span>
            <span *ngIf="row.addresses && row.addresses.length > 0">
              {{row.addresses[0]!.street | titlecase}} {{row.addresses[0]!.streetNo}},
              {{row.addresses[0]!.zip}} {{row.addresses[0]!.city | titlecase}}
            </span>
             <span *ngIf="!row.addresses || row.addresses.length === 0">
             
            </span>
        </mat-cell>
      
      </ng-container>

      <ng-container matColumnDef="meteringPointGroups">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'meteringpoints.table.groups' | translate}}
        </mat-header-cell>
        <mat-cell *matCellDef="let row">          
          <ng-container *ngIf="row.parentGroups && row.parentGroups.length > 0">
            <div class="sx-chip" *ngFor="let parentGroup of row.parentGroups">
              {{parentGroup.name}}
            </div>
          </ng-container>
          <div class="sx-chip sx-chip--purple" *ngIf="row.type === 'LOG'">{{'meteringpoints.card.logic_chip' | translate}}
          </div>
          <div class="sx-chip sx-chip--magenta" *ngIf="row.hasFunctionControl || containedMeteringPointsHasFunctionControl(row)">
            {{'meteringpoints.card.functionControl' | translate}}
          </div>
          <div class="sx-chip sx-chip--blue" *ngIf="row.hasIntelligy">
            {{'meteringpoints.card.hasIntelligy' | translate}}
          </div>
          <div class="sx-chip sx-chip--indigo" *ngIf="row.isWhiteLabel">
            {{row.externalOrganisationAlias}}
          </div>
          <div *ngIf="filterDisruption(row.disruptionInfos)" class="sx-metering-point__disruption-icon">
            <div matTooltip="{{'disruptions.delivery_disruption_tooltip' | translate}}" matTooltipClass="sx-metering-point__tooltip">
              <svg class="sx-metering-point__planned-icon" *ngIf="filterDisruption(row.disruptionInfos).disturbanceType === DisturbanceTypeEnum.Delivery">
                <use xlink:href="#baseline-warning-24px" href="#baseline-warning-24px" />
              </svg>
            </div>
            <div matTooltip="{{'disruptions.planned_tooltip' | translate}}" matTooltipClass="sx-metering-point__tooltip">
              <svg class="sx-metering-point__planned-icon" *ngIf="filterDisruption(row.disruptionInfos).isPlanned && filterDisruption(row.disruptionInfos).disturbanceType !== DisturbanceTypeEnum.Delivery">
                <use xlink:href="#baseline-warning-24px" href="#baseline-warning-24px" />
              </svg>
            </div>
            <div matTooltip="{{'disruptions.unplanned_tooltip' | translate}}" matTooltipClass="sx-metering-point__tooltip">
              <svg class="sx-metering-point__unplanned-icon" *ngIf="!filterDisruption(row.disruptionInfos).isPlanned && filterDisruption(row.disruptionInfos).disturbanceType !== DisturbanceTypeEnum.Delivery">
                <use xlink:href="#baseline-warning-24px" href="#baseline-warning-24px" />
              </svg>
            </div>
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>

    <mat-paginator #paginator [length]="dataSource?.data.length" (page)="onPagination($event)"  [pageIndex]="currentPage" [pageSize]="pageSize"
      [pageSizeOptions]="[10, 25, 50, 100, 250]">
    </mat-paginator>
    </div>    
   
</div>
